<template>
  <div>
    <header>
      <LogoTile :fixed="false" />
      <router-link to="/">
        <div class="home-link">
          home
          <span class="home-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path fill="#2c3e50" d="M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z"/></svg></span>
        </div>
      </router-link>
    </header>
    <div class="page-container">
      <div class="text-block"  v-html="richTextHtml" />
    </div>
  </div>
</template>

<script>
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import LogoTile from '@/components/LogoTile'

const contentful = require('contentful')
const SPACE_ID = process.env.VUE_APP_SPACE_ID
const ACCESS_TOKEN = process.env.VUE_APP_CONTENT_DELIVERY

const client = contentful.createClient({
  // This is the space ID. A space is like a project folder in Contentful terms
  space: SPACE_ID,
  // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
  accessToken: ACCESS_TOKEN
})

export default {
  components: {
    LogoTile
  },

  data () {
    return {
      aboutData: null,
      richTextHtml: null
    }
  },

  async created () {
    const { items } = await client.getEntries({
      content_type: 'about',
      include: 2
    })
    this.richTextHtml = documentToHtmlString(items[0].fields.about)
  },

  mounted () {
    // Remove style from body if this has been set on the homepage
    const body = document.querySelector('body')
    body.setAttribute('style', 'background: white; overflow-y: scroll;')
  }
}
</script>

<style scoped>
header {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 18px;
  justify-content: space-between;
}
.home-link {
  display: flex;
}
.home-icon {
  padding: 0 1rem;
}
</style>
